import {_request, _requestForm} from "./api";

export const add = (data, document_guid) => {
    let params = data
    return new Promise((resolve, reject) => {
        return _request({
            target: `license/${document_guid}`, method: 'POST', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const edit = (data, termination_guid) => {
    let params = data
    return new Promise((resolve, reject) => {
        return _request({
            target: `license/${termination_guid}`, method: 'PUT', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const remove = (competitions_license_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `license/${competitions_license_guid}`, method: 'DELETE'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const item = (documents_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `license/${documents_guid}`, method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};


export const list = (data) => {
    let params = data;
    console.log('list',data)
    return new Promise((resolve, reject) => {
        return _request({
            target: 'license', method: 'GET', params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listPlayers = (document_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `license/players/${document_guid}`, method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listPlayersByClub = (club_guid, competitions_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `license/players-by-club/${club_guid}/${competitions_guid}`, method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listStaffByClub = (club_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `license/staff-by-club/${club_guid}`, method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listUnusedPlayers = (document_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `license/players-unused/${document_guid}`, method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const processLicense = (documents_guid, data) => {
    let params = data;
    return new Promise((resolve, reject) => {
        return _request({
            target: `license/process-document/${documents_guid}`, method: 'PUT', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const setToggleVerified = (competitions_license_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `license/verified/${competitions_license_guid}`, method: 'PUT'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};


